
import React, { useState, useEffect, use } from 'react';
import { NavLink } from 'react-router-dom';
import { Nav, UncontrolledTooltip } from 'reactstrap';
import RenderIcon from '../commons/RenderIcon';


const CollapsedMenuWithSIdebarGroupIcon = (props) => {

    const useMediaQuery = (query) => {
        const [matches, setMatches] = useState(false);

        useEffect(() => {
            const media = window.matchMedia(query);
            if (media.matches !== matches) {
                setMatches(media.matches);
            }
            const listener = () => setMatches(media.matches);
            window.addEventListener("resize", listener);
            return () => window.removeEventListener("resize", listener);
        }, [matches, query]);

        return matches;
    };
    let menuItems = props.items;
    const { customIcons } = props
    // console.log("collapse", props)
    const [hovered, setHovered] = useState(null);
    const [active, setActive] = useState(0);
    const [isClosedMenu, setIsCloseMenu] = useState(null);
    const [activeMenu, setActiveMenu] = useState({})
    const [activeChild, setActiveChild] = useState(false);
    const [activeChildIndex, setActiveChildIndex] = useState(null)
    const [hoverChildIndex, setHoverChildIndex] = useState(null)
    const [animate, setAnimate] = useState(false);
    const changeSmall = useMediaQuery("(max-height: 550px)");
    const [hoverText, setHoverText] = useState('');
    const [allGroupIcon, setAllGroupIcon] = useState(null)
    const [parentItemMenu, setParentItemMenu] = useState(null)
    const [parentItemMenuIndex, setParentItemMenuIndex] = useState(null)

    let delay = 1;
    useEffect(() => {
        setAnimate(true);
        let timer = setTimeout(() => setAnimate(false), delay * 1000);

        return () => {
            clearTimeout(timer);
        };

    }, [active, delay]);
    useEffect(() => {
        props.toggleIsExpanded()

    }, []);

    const onClickMenuHandler = (item, index, value) => {
        setActive(index)
        setActiveMenu(item)
        setParentItemMenu(value)
        console.log("Active Icon", item)

        window.storeExpand = true
        if (item.length === 1 && item[0].childMenus && item[0].childMenus.length === 0) {
            console.log("In Condition")
            setIsCloseMenu(index)
            props.collapsewithsidebartoggleIsExpandedFalse()
        }
        else if (isClosedMenu === index) {
            setIsCloseMenu(null)
            props.toggleIsExpanded()
        }
        else {
            setIsCloseMenu(index)
            props.collapsewithsidebartoggleIsExpanded()
        }
        // if (item && item.childMenus && item.childMenus.length === 0) {
        //     window.location.href = `/app/${item.friendlyUrl.toLowerCase()}`;
        // }

    }
    const handleMouseEnter = (text, index) => {
        setHoverText(text);
        setHovered(index)
    };

    const handleMouseLeave = () => {
        setHoverText('');
        setHovered(null)
    };
    const handleChildMouseEnter = (index) => {
        setHoverChildIndex(index)
    };

    const handleChildMouseLeave = () => {
        setHoverChildIndex(null)
    };
    const childClickHandler = (child, index) => {
        setActiveChild(child)
        setActiveChildIndex(index)
    }
    let groupedData
    if (props && props.items && props.items.length !== 0) {
        groupedData = props.items.reduce((acc, item) => {
            try {
                let key = "fa-joomla_menuIcon";

                if (item.properties) {
                    const customeIconObject = JSON.parse(item.properties);
                    if (
                        customeIconObject.web &&
                        customeIconObject.web.customWebIcon
                    ) {
                        key = `${customeIconObject.web.customWebIcon}_customIcon`;
                    }
                    else if (!customeIconObject.web) {
                        if (item.menuIcon) {
                            key = `${item.menuIcon}_menuIcon`;
                        }
                        else {
                            key = "fa-joomla_menuIcon"
                        }
                    }
                    else {
                        return acc;
                    }
                }
                else if (item.menuIcon) {
                    key = `${item.menuIcon}_menuIcon`;
                }
                else {
                    key = "fa-joomla_menuIcon"
                }

                if (!acc[key]) {
                    acc[key] = [];
                }

                acc[key].push(item);
            } catch (error) {
                // You can choose to skip or handle the error item differently
            }
            return acc;
        }, {});

    }
    return (
        <div className={`col_with_sidebar ${props.isExpanded && "expanded"} collapse_with_sidebar collapse_with_sidebar_gIcon`} >

            <div className='gIcon_handle'>
                {
                    groupedData && Object.entries(groupedData).map(([key, value], index) => {
                        let parentItemCustomIcon = null
                        let menuIcon = null
                        if (key.endsWith('_customIcon')) {
                            parentItemCustomIcon = key.replace('_customIcon', '')
                            menuIcon = "fa-500px"
                        }
                        else {
                            menuIcon = key.replace('_menuIcon', '')
                        }
                        const parentItemIcon = null
                        const parentItemCustomIconSize = null
                        const iconConfig = {
                            cssClass: menuIcon,
                            cssClass2: parentItemIcon,
                            cssCustomIconMenu: parentItemCustomIcon,
                            webIconSizeMenu: parentItemCustomIconSize
                        }
                        // console.log("ACtive", active)
                          const path = `${props.baseWorkflowRoute}/${groupedData[key][0].friendlyUrl.toLowerCase()}`;
                                                const childPath = `${path}`;
                        return <div key={index} className='icongroup_parentDiv'>
                            {
                                groupedData && groupedData[key] && groupedData[key].length === 1 && groupedData[key][0].childMenus && groupedData[key][0].childMenus.length === 0 ? <NavLink onClick={() => onClickMenuHandler(groupedData[`${key}`], index, value)} to={`${props.baseWorkflowRoute}/${groupedData[key][0].friendlyUrl.toLowerCase()}`}>
                                    <div
                                        className={`boxicon-container ${props.isExpanded && "expanded-boxicon-container  colla-with-side-main-div"
                                            } ${props.isExpanded && active === index ? "colla-with-side-main-div activeMenu" : "colla-with-side-main-div"}`}


                                    >
                                        <RenderIcon config={iconConfig} customIcons={customIcons} />
                                    </div>
                                </NavLink>
                                    :
                                    <div
                                        className={`boxicon-container ${props.isExpanded && "expanded-boxicon-container  colla-with-side-main-div"
                                            } ${props.isExpanded && active === index ? "colla-with-side-main-div activeMenu" : "colla-with-side-main-div"}`}

                                        onClick={() => onClickMenuHandler(groupedData[`${key}`], index, value)}
                                    >
                                        <RenderIcon config={iconConfig} customIcons={customIcons} />
                                    </div>
                            }


                        </div>

                    })
                }


            </div>

            <div className='gIcon_parentItem'>
                {parentItemMenu && parentItemMenu.map((item, index) => {
                    if (item.alwaysInTopMenu) return null;
                    let middle = true;
                    const hasChildren = item.childMenus && item.childMenus.length > 0;
                    return hasChildren ? (
                        <div
                            key={index}
                            className={`boxicon-container ${props.isExpanded && "expanded-boxicon-container"
                                }`}
                            // onMouseEnter={() => {
                            //   if (middle) {
                            //     setHovered(index);
                            //   }
                            //   if(hasChildren){
                            //       setActiveChild(!activeChild);
                            //       setActive(index);
                            //   }
                            // }}
                            // onMouseLeave={() => {
                            //   if (middle) {
                            //     setHovered(null);
                            //   }
                            //   if(hasChildren){
                            //       setActiveChild(!activeChild);
                            //       setActive(index);
                            //   }
                            // }}
                            onClick={() => {
                                if (!hasChildren) {
                                    setParentItemMenuIndex(index);
                                } else {
                                    setActiveChild(!activeChild);
                                    setParentItemMenuIndex(index);
                                }
                            }}
                        >
                            <div
                                className={`${middle && "boxicon"} 
                                        ${parentItemMenuIndex === index && "active"}
                                        `}
                                name={item.menuIcon}
                                color={
                                    hovered === index || parentItemMenuIndex === index ? "white" : item.color
                                }
                                animation={parentItemMenuIndex === index && animate ? "tada" : ""}
                                rotate={item.rotate}
                            >

                                {/* {item.menuIcon ? <i className={` fa ${item.menuIcon} menuIcon ${parentItemMenuIndex === index && 'activeIcon iconBounce'}`}></i> :
                                <i className={` fa fa-inbox menuIcon ${parentItemMenuIndex === index && 'activeIcon iconBounce'}`}></i>
                                } */}


                                <div
                                    className={`description descrption-child
                              ${props.isExpanded && "show-description"}
                              ${active === index && "active-description"} `

                                    }
                                    style={props.isExpanded ? {} : { display: 'none' }}
                                >
                                    <p className={`${hasChildren ? 'pChild' : ''}`}> {item.title}</p>
                                    <span className="right-icon-container-Child">
                                        <i className={`fa fa-chevron-right ${activeChild ? 'toggle-up' : 'toggle-down'}`}></i>
                                    </span>
                                </div>
                            </div>
                            <div>
                                {activeChild && parentItemMenuIndex === index && <DesktopLevelTwoMenu {...props}>
                                    <ul className={`sidebarWithTopbar-items  `}>
                                        {
                                            props.isExpanded && item.childMenus.map((child, childIndex) => {
                                                if (child.hideInMenu) return null;
                                                const path = `${props.baseWorkflowRoute}/${child.friendlyUrl.toLowerCase()}`;
                                                const childPath = `${path}`;
                                                return <NavLink className="sidebarWithTopbar-item" to={childPath}>
                                                    <li className="sidebarWithTopbar-item-link" >
                                                        <span className="left-icon-link-child">
                                                            <i className={`fa ${child.menuIcon}`}></i>
                                                        </span>
                                                        {child.title}

                                                    </li>
                                                </NavLink>
                                            })
                                        }
                                    </ul>
                                </DesktopLevelTwoMenu>}
                            </div>
                        </div>
                    ) : (
                        <li
                            key={index}
                            className={`boxicon-container ${props.isExpanded && "expanded-boxicon-container"
                                }`}
                            onClick={() => {
                                if (middle) {
                                    setParentItemMenuIndex(index);
                                }
                            }}
                            id={item.friendlyUrl}
                        >
                            <NavLink to={`/app/${item.friendlyUrl.toLowerCase()}`}
                                className={`${middle && "boxicon"} 
                                      ${parentItemMenuIndex === index && "active"}
                                      `}
                                name={item.menuIcon}

                                color={
                                    hovered === index || parentItemMenuIndex === index ? "white" : item.color
                                }
                                animation={parentItemMenuIndex === index && animate ? "tada" : ""}
                                rotate={item.rotate}
                            >
                                {/* {item.menuIcon ? <i className={` fa ${item.menuIcon} menuIcon ${parentItemMenuIndex === index && 'activeIcon iconBounce'}`}></i> :
                                <i className={` fa fa-inbox menuIcon ${parentItemMenuIndex === index && 'activeIcon iconBounce'}`}></i>} */}

                                {!props.isExpanded && <UncontrolledTooltip delay={100} placement='right' target={item.friendlyUrl}>
                                    {item.title}
                                </UncontrolledTooltip>}
                                <p
                                    className={`description 
                            ${props.isExpanded && "show-description"}
                            ${parentItemMenuIndex === index && "active-description"}`}

                                    style={props.isExpanded ? {} : { display: 'none' }}
                                >
                                    {item.title}
                                </p>

                            </NavLink>
                        </li>
                    );
                })}
            </div>

        </div>
    );
};

const DesktopLevelTwoMenu = (props) => {
    return <div className={`sidebarWithTopbar ${props.isExpanded && "expandedChildMenu"}`} >
        {props.children}
    </div>
}

export default CollapsedMenuWithSIdebarGroupIcon;